import { SVGProps } from '@components/Icon/types';

export const Mobile = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(5, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.203 14.2522C8.13568 14.3452 8.8729 15.0722 8.96713 15.9922L8.97707 16.1919C8.97707 17.2049 8.2024 18.0328 7.203 18.1325L7.00045 18.1423C5.97312 18.1423 5.13362 17.3778 5.03287 16.3917L5.02293 16.1919C5.02328 15.1115 5.90493 14.2424 7.00045 14.2424L7.203 14.2522ZM7.00045 15.3723C6.53559 15.3723 6.16983 15.7336 6.16948 16.1919L6.17309 16.2766C6.21497 16.6943 6.56442 17.0115 7.00045 17.0115L7.08635 17.007C7.48124 16.9681 7.78871 16.6662 7.82781 16.2766L7.83143 16.1919C7.8311 15.7624 7.50926 15.4185 7.08635 15.3768L7.00045 15.3723Z"
        fill={fill}
      />
      <path
        d="M4.64587 1.85767L4.72092 1.86123C5.06445 1.89485 5.32984 2.15649 5.36382 2.49532L5.36744 2.56934C5.36736 2.9436 5.08907 3.24138 4.72092 3.27745L4.64587 3.28101H3.86101C3.48134 3.28101 3.17943 3.00672 3.14306 2.64336L3.13944 2.56934C3.13959 2.16993 3.456 1.85767 3.86101 1.85767H4.64587Z"
        fill={fill}
      />
      <path
        d="M10.139 1.85767C10.5185 1.85784 10.8205 2.13215 10.8569 2.49532L10.8606 2.56934C10.8605 2.96871 10.5439 3.28083 10.139 3.28101H7.00045C6.62079 3.28101 6.31887 3.00672 6.2825 2.64336L6.27889 2.56934C6.27903 2.16993 6.59545 1.85767 7.00045 1.85767H10.139Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7087 0C12.9768 0.000190987 13.9998 1.00913 14 2.25988V17.7401C14 18.991 12.9769 19.9998 11.7087 20H2.29129C1.02291 20 0 18.9911 0 17.7401V2.25988C0.000151933 1.00902 1.02301 5.0904e-06 2.29129 0H11.7087ZM2.29129 1.13083C1.65367 1.13083 1.1467 1.63104 1.14655 2.25988V17.7401C1.14655 18.3691 1.65358 18.8692 2.29129 18.8692H11.7087C12.3463 18.869 12.8535 18.369 12.8535 17.7401V2.25988C12.8533 1.63116 12.3462 1.13102 11.7087 1.13083H2.29129Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'mobile';
